import { request } from "../../api/api";

export const getModule = () => {
    return request.get(`/user/getModule`);
  };
  export const userFootFallTracking = (data) => {
    return request.post(`/user/userFootFallTracking/`, data);
  };
  export const getUserList = () => {
    return request.get(`/user/getUserList/`);
  };
  // Updated function to accept params for filtering and pagination
  export const getUserFootfallReport = (params) => {
    return request.get(`/user/getUserFootfallReport/`, { params });
  };